import React from "react";
import AppIcon from "../../../components/ui/AppIcon";

export default function PinnedMessageItem({ message, onUnpin, onClick }) {
    const messageId = message._id || message.id;
    const getSenderName = () => {
        if (message.senderName) return message.senderName;
        if (message.sender && typeof message.sender === 'object') {
            return message.sender.name || message.sender.displayName || message.sender.username;
        }
        return message.sender || "User";
    };

    const getSenderAvatar = () => {
        const name = getSenderName();
        // Priority order matches normalizeDMMessage / normalizeChannelMessage shape
        if (message.senderInfo?.profilePhoto) return message.senderInfo.profilePhoto;
        if (message.senderAvatar) return message.senderAvatar;
        if (message.sender && typeof message.sender === 'object' && message.sender.profilePhoto) {
            return message.sender.profilePhoto;
        }
        if (message.profilePhoto) return message.profilePhoto;
        // Only fall back to generated avatar when profilePhoto is genuinely absent
        return `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=random`;
    };

    const formatDate = (ts) => {
        if (!ts) return "";
        try {
            const date = new Date(ts);
            if (isNaN(date.getTime())) return ts;
            return date.toLocaleDateString([], { month: 'short', day: 'numeric' });
        } catch (e) {
            return ts;
        }
    };

    const content = message.text || message.message || message.content || "";
    const snippet = content.length > 100 ? content.substring(0, 100) + "..." : content;

    return (
        <div
            className="flex-shrink-0 w-60 sm:w-72 max-w-[78vw] p-3 rounded-xl bg-[var(--bg-surface)] border border-white/5 hover:border-stone-500/30 transition-all cursor-pointer group"
            onClick={() => onClick && onClick(message)}
        >
            <div className="flex items-start gap-3">
                <img
                    src={getSenderAvatar()}
                    className="w-8 h-8 rounded-lg object-cover border border-white/10"
                    alt={getSenderName()}
                />
                <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                        <span className="text-xs font-bold text-black truncate">{getSenderName()}</span>
                        <span className="text-[10px] text-[var(--text-muted)]">{formatDate(message.timestamp || message.createdAt)}</span>
                    </div>
                    <p className="text-xs text-[var(--text-muted)] line-clamp-2">{snippet}</p>
                </div>
                <div className="flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">

                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            onUnpin && onUnpin(messageId);
                        }}
                        className="p-1.5 rounded-lg hover:bg-red-500/20 text-[var(--text-muted)] hover:text-red-400 transition-all"
                        title="Unpin message"
                    >
                        <AppIcon name="XMarkIcon" size={12} />
                    </button>
                </div>
            </div>
        </div>
    );
}
